import { formatDateTime } from 'utils/helpers';

export const WORK_IN_PROGRESS_REPORT = "Work In Progress V3 Report";
export const WORK_IN_PROGRESS_REPORT_DESCRIPTION = "Displays the Work In Progress V3 report for the date range provided";
export const WORK_IN_PROGRESS_REPORT_TITLE = "workInProgress";

export const columns = [
  { name: 'repairerGroup', title: 'Repairer Group' },
  { name: 'repairerName', title: 'Repairer Name' },
  { name: 'activeWebId', title: 'ActiveWeb Id' },
  { name: 'schemeCode', title: 'Scheme Code' },
  { name: 'registration', title: 'Registration' },
  { name: 'claimReference', title: 'Claim Reference' },
  { name: 'status', title: 'Status' },
  { name: 'dtgCreated', title: 'Created Date', type: 'date' },
  { name: 'dtgOnsite', title: 'On Site Date', type: 'date' },
  { name: 'dtgAuthorised', title: 'Authorised Date', type: 'date' },
  { name: 'dtgPartsOrdered', title: 'Parts Ordered Date', type: 'date' },
  { name: 'dtgEstimatedCompletion', title: 'Estimated Completion Date', type: 'date' },
  { name: 'replacementVehicleModel', title: 'Replacement Vehicle' },
  {
    name: 'dtgReplacementVehicleKeysOut',
    title: 'Replacement Vehicle Keys Out Date',
    type: 'date'
  },
  {
    name: 'replacementVehicleKeysOut',
    title: 'Replacement Vehicle Keys Out',
  },
  { name: 'dtgLastDataUpdate', title: 'Last Data Updated', type: 'date' },
  { name: 'dtgLastStatusChange', title: 'Last Status Change', type: 'date' },
  { name: 'dtgLastActivity', title: 'Last Activity Date', type: 'date' },
  { name: 'lastActivityBy', title: 'Last Activity By' },
  { name: 'dtgLatestPdelay', title: 'Latest PDelay', type: 'date' },
  { name: 'statusAge', title: 'Status Age' },
  { name: 'dataAge', title: 'Data Age' },
  { name: 'lastActivityAge', title: 'Last Activity Age' },
];

export const reportHeaderTagLine = `Report produced on ${formatDateTime(new Date())}`;

// TODO: remove after testing
export const mockedReportData = [
  {
    repairerName: "John Smith",
    repairerGroup: "Group A",
    activeWebId: "WEB12345",
    schemeCode: "SC001",
    registration: "ABC1234",
    claimReference: "CLM0001",
    status: "In Progress",
    dtgCreated: "2024-04-01T08:30:00Z",
    dtgOnsite: "2024-04-02T09:00:00Z",
    dtgAuthorised: "2024-04-01T10:00:00Z",
    dtgPartsOrdered: "2024-04-03T11:00:00Z",
    dtgEstimatedCompletion: "2024-04-10T17:00:00Z",
    dtgReplacementVehicleKeysOut: "2024-04-02T12:00:00Z",
    replacementVehicleKeysOut: "Yes",
    replacementVehicleModel: "Toyota Corolla",
    dtgLastDataUpdate: "2024-04-04T14:00:00Z",
    dtgLastStatusChange: "2024-04-04T15:00:00Z",
    dtgLastActivity: "2024-04-04T16:00:00Z",
    lastActivityBy: "John Smith",
    dtgLatestPdelay: null,
    statusAge: 3,
    dataAge: 1,
    lastActivityAge: 0,
    reportMode: "Detailed"
  },
  {
    repairerName: "Emily Johnson",
    repairerGroup: "Group B",
    activeWebId: "WEB67890",
    schemeCode: "SC002",
    registration: "XYZ5678",
    claimReference: "CLM0002",
    status: "Awaiting Parts",
    dtgCreated: "2024-03-28T07:45:00Z",
    dtgOnsite: "2024-03-29T08:15:00Z",
    dtgAuthorised: "2024-03-28T09:00:00Z",
    dtgPartsOrdered: "2024-03-30T10:30:00Z",
    dtgEstimatedCompletion: "2024-04-12T16:00:00Z",
    dtgReplacementVehicleKeysOut: null,
    replacementVehicleKeysOut: "No",
    replacementVehicleModel: "Ford Focus",
    dtgLastDataUpdate: "2024-04-01T13:00:00Z",
    dtgLastStatusChange: "2024-04-01T14:00:00Z",
    dtgLastActivity: "2024-04-01T15:00:00Z",
    lastActivityBy: "Emily Johnson",
    dtgLatestPdelay: "2024-04-02T10:00:00Z",
    statusAge: 7,
    dataAge: 3,
    lastActivityAge: 2,
    reportMode: "Summary"
  },
  {
    repairerName: "Michael Brown",
    repairerGroup: "Group C",
    activeWebId: "WEB11223",
    schemeCode: "SC003",
    registration: "LMN3456",
    claimReference: "CLM0003",
    status: "Completed",
    dtgCreated: "2024-03-20T06:00:00Z",
    dtgOnsite: "2024-03-21T07:00:00Z",
    dtgAuthorised: "2024-03-20T08:00:00Z",
    dtgPartsOrdered: "2024-03-22T09:00:00Z",
    dtgEstimatedCompletion: "2024-03-28T17:00:00Z",
    dtgReplacementVehicleKeysOut: "2024-03-21T10:00:00Z",
    replacementVehicleKeysOut: "Yes",
    replacementVehicleModel: "Honda Civic",
    dtgLastDataUpdate: "2024-03-29T12:00:00Z",
    dtgLastStatusChange: "2024-03-29T13:00:00Z",
    dtgLastActivity: "2024-03-29T14:00:00Z",
    lastActivityBy: "Michael Brown",
    dtgLatestPdelay: null,
    statusAge: 0,
    dataAge: 1,
    lastActivityAge: 1,
    reportMode: "Detailed"
  },
  {
    repairerName: "Sarah Davis",
    repairerGroup: "Group A",
    activeWebId: "WEB44556",
    schemeCode: "SC004",
    registration: "QRS7890",
    claimReference: "CLM0004",
    status: "Pending Authorisation",
    dtgCreated: "2024-04-05T09:00:00Z",
    dtgOnsite: null,
    dtgAuthorised: null,
    dtgPartsOrdered: null,
    dtgEstimatedCompletion: null,
    dtgReplacementVehicleKeysOut: null,
    replacementVehicleKeysOut: "No",
    replacementVehicleModel: "Nissan Altima",
    dtgLastDataUpdate: "2024-04-05T10:00:00Z",
    dtgLastStatusChange: "2024-04-05T10:30:00Z",
    dtgLastActivity: "2024-04-05T11:00:00Z",
    lastActivityBy: "Sarah Davis",
    dtgLatestPdelay: null,
    statusAge: 1,
    dataAge: 0,
    lastActivityAge: 0,
    reportMode: "Summary"
  },
  {
    repairerName: "David Wilson",
    repairerGroup: "Group B",
    activeWebId: "WEB77889",
    schemeCode: "SC005",
    registration: "TUV1234",
    claimReference: "CLM0005",
    status: "On Hold",
    dtgCreated: "2024-03-15T05:30:00Z",
    dtgOnsite: "2024-03-16T06:00:00Z",
    dtgAuthorised: "2024-03-15T07:00:00Z",
    dtgPartsOrdered: "2024-03-17T08:00:00Z",
    dtgEstimatedCompletion: "2024-04-01T17:00:00Z",
    dtgReplacementVehicleKeysOut: null,
    replacementVehicleKeysOut: "No",
    replacementVehicleModel: "Chevrolet Malibu",
    dtgLastDataUpdate: "2024-03-20T09:00:00Z",
    dtgLastStatusChange: "2024-03-20T10:00:00Z",
    dtgLastActivity: "2024-03-20T11:00:00Z",
    lastActivityBy: "David Wilson",
    dtgLatestPdelay: "2024-03-25T12:00:00Z",
    statusAge: 10,
    dataAge: 5,
    lastActivityAge: 4,
    reportMode: "Detailed"
  }
];
